import { Box, Container, Flex, Grid, SystemStyleObject } from '@chakra-ui/react';
import { Image } from '@components/AssetWrapper';
import { ButtonFullWidthMobile } from '@components/Button';
import { MarqueeItem } from '@components/MarqueeAnimation';
import { GradientShadowOverlay, LANDING_ROUTES, pxToRem } from '@cyberkongz/ui';
import { PropsWithChildren } from 'react';

export function IntroSectionWrapper({
  children,
  marqueeImage,
  stylesContainer,
  bgGradient,
  openseaCollectionLink,
}: {
  marqueeImage?: 'genesis' | 'baby';
  stylesContainer?: SystemStyleObject;
  bgGradient?: string;
  openseaCollectionLink: string;
} & PropsWithChildren) {
  return (
    <Box
      css={{
        pt: marqueeImage ? [0, 40] : 40,
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          position: 'absolute',
          display: 'block',
          content: '""',
          left: '50%',
          top: marqueeImage ? [marqueeImage === 'baby' ? '29.28%' : '17.28%', '-9.78%'] : '-9.78%',
          width: '131%',
          height: '164%',
          transform: 'translateX(-82.5%)',
          maxW: pxToRem(1892),
          maxHeight: pxToRem(1440),
          background:
            bgGradient ||
            'radial-gradient(43.39% 43.39% at 50% 50%, rgba(255, 0, 229, 0.39) 0%, rgba(255, 0, 229, 0.3) 0.01%, rgba(255, 0, 229, 0) 100%)',
        },
        ...stylesContainer,
      }}
    >
      {marqueeImage ? (
        <Flex
          css={{
            maxHeight: [pxToRem(400), 'none'],
            position: ['relative', 'absolute'],
            right: [0, null, '50%'],
            justifyContent: 'end',
            transform: ['none', null, 'translateX(170%)'],
            top: 0,
            gap: 4,
            mb: [4, 0],
            img: {
              maxWidth: [pxToRem(120), '100%'],
            },
          }}
        >
          <MarqueeItem direction="up">
            <Image
              src={`/static/kollection/${marqueeImage}_column_1.png`}
              alt="Cyberkongz avatar images"
            />
          </MarqueeItem>
          <MarqueeItem direction="down">
            <Image
              src={`/static/kollection/${marqueeImage}_column_2.png`}
              alt="Cyberkongz avatar images"
            />
          </MarqueeItem>
          <Box display={['block', 'none']}>
            <GradientShadowOverlay height={pxToRem(290)} />
          </Box>
        </Flex>
      ) : null}
      <Container position="relative" zIndex="2">
        <Grid gap={10}>
          {children}
          <Flex css={{ gap: 6, flexDirection: ['column', 'row'] }}>
            <ButtonFullWidthMobile href={LANDING_ROUTES.KOLLECTIONS}>
              View Kollections
            </ButtonFullWidthMobile>
            <ButtonFullWidthMobile href={openseaCollectionLink} variant="displayOutline">
              View on opensea
            </ButtonFullWidthMobile>
          </Flex>
        </Grid>
      </Container>
      <GradientShadowOverlay top height={[pxToRem(76), pxToRem(290)]} />
      <GradientShadowOverlay height={pxToRem(290)} />
    </Box>
  );
}
